import { FormControl, FormControlLabel, FormHelperText, Grid } from '@material-ui/core';
import { FormikErrors, FormikHandlers, FormikHelpers, getIn } from 'formik';
import React from 'react';
import Label from '../../../../common/components/label';
import { ISi } from '../../../../common/dtos/SiDto';
import { ClaimantEmployerAgencyCodes_class } from '../../../../common/enums/ClaimantEmployerAgencyCodes';
import { IndentGrid, MHARadio } from '../../../../common/styles/styles';

interface Props {
  label: string;
  name: string;
  value: number | undefined;
  errors: FormikErrors<ISi>;
  handleBlur: FormikHandlers["handleBlur"];
  setFieldValue: FormikHelpers<ISi>["setFieldValue"];
  isReadOnly: boolean;
}

const ClaimantEmployerAgencyCodeField: React.FC<Props> = ({ label, name, value, errors, handleBlur, setFieldValue, isReadOnly }) => {

  return (
    <>
      <Grid item xs={12}>
        <Label>{label}</Label>
      </Grid>
      <IndentGrid container direction="row">
        <FormControl error={Boolean(getIn(errors, name))} >
          <IndentGrid container direction="row">
            <FormControlLabel
              checked={value === ClaimantEmployerAgencyCodes_class.enum.C}
              value={value}
              data-cy={`sidesResponse_${name}_Claimant`}
              onChange={() => setFieldValue(name, ClaimantEmployerAgencyCodes_class.enum.C)}
              onBlur={handleBlur}
              control={<MHARadio disabled={isReadOnly} size="small" name={name} />}
              label="Claimant" />
            <FormControlLabel
              checked={value === ClaimantEmployerAgencyCodes_class.enum.E}
              value={value}
              data-cy={`sidesResponse_${name}_EmployerClient`}
              onChange={() => setFieldValue(name, ClaimantEmployerAgencyCodes_class.enum.E)}
              onBlur={handleBlur}
              control={<MHARadio disabled={isReadOnly} name={name} size="small" />}
              label="Employer Client" />
            <FormControlLabel
              checked={value === ClaimantEmployerAgencyCodes_class.enum.A}
              value={value}
              data-cy={`sidesResponse_${name}_Agency`}
              onChange={() => setFieldValue(name, ClaimantEmployerAgencyCodes_class.enum.A)}
              onBlur={handleBlur}
              control={<MHARadio disabled={isReadOnly} name={name} size="small" />}
              label="Agency" />
            <FormControlLabel
              checked={value === undefined}
              value={value}
              data-cy={`sidesResponse_${name}_undefined`}
              onChange={() => setFieldValue(name, undefined)}
              onBlur={handleBlur}
              control={<MHARadio disabled={isReadOnly} name={name} size="small" />}
              label="N/A" />
          </IndentGrid>
          {Boolean(getIn(errors, name)) &&
            <FormHelperText
            id={`${name}-helper_text`}
          >
              {getIn(errors, name)}
            </FormHelperText>
          }
        </FormControl>
      </IndentGrid>
    </>
  );

}

export default ClaimantEmployerAgencyCodeField;